import React from "react";
import {
  AntdLayout,
  AntdHeader,
  AntdContent,
  AntdFooter,
} from "../components/Base/BaseLayout";
import { Header } from "../components/Header";
import { BottomNavigation } from "../components/BottomNavigation";
import { PullToRefresh } from "../components/Base/PullToRefresh";
import { LayoutProps } from "./Layout.types";
import { useNavigation, ROUTES } from "../utils/navigation";
import "./Layout.scss";
import { useBottomNavInviteTarget } from "../modules/homeDisplay/hooks";
import { DownloadAppBar } from "../components/DownloadAppBar";
import { useGlobalValue } from "../stores/GlobalState";

export const Layout: React.FC<LayoutProps> = ({
  children,
  className = "",
  variant = "primary",
  testId,
  cannotRefresh,
}) => {
  const { navigate, getCurrentPath } = useNavigation();
  const [downloadAppBarVisible] = useGlobalValue("downloadAppBarVisible", true);
  const inviteTarget = useBottomNavInviteTarget();
  const handleBottomNavClick = (itemId: string) => {
    const navigationState = { fromBottomNav: true };

    switch (itemId) {
      case "home":
        navigate(ROUTES.HOME, { state: navigationState });
        break;
      case "vip":
        navigate(ROUTES.VIP, { state: navigationState });
        break;
      case "event":
        navigate(ROUTES.EVENT_CENTER, { state: navigationState });
        break;
      case "profile":
        navigate(ROUTES.PROFILE, { state: navigationState });
        break;
      case "agent-center":
        if (inviteTarget !== "INVITE_PAGE") {
          navigate(ROUTES.AGENT_CENTER, { state: navigationState });
        } else {
          navigate(ROUTES.INVITE_FRIENDS, { state: navigationState });
        }
        break;
      default:
        console.log("Unknown navigation item:", itemId);
    }
  };

  const getActiveItem = () => {
    const currentPath = getCurrentPath();
    if (currentPath === ROUTES.EVENT_CENTER) return "event";
    if (currentPath === ROUTES.VIP) return "vip";
    if (currentPath === ROUTES.HOME || currentPath === ROUTES.HOME_ALT)
      return "home";
    if (
      currentPath === ROUTES.INVITE_FRIENDS ||
      currentPath === ROUTES.AGENT_CENTER
    )
      return "agent-center";
    if (currentPath === ROUTES.PROFILE) return "profile";
    return "home";
  };

  const shouldShowHeader = () => {
    const currentPath = getCurrentPath();
    return (
      currentPath === ROUTES.HOME ||
      currentPath === ROUTES.HOME_ALT ||
      currentPath === ROUTES.PROFILE ||
      currentPath === ROUTES.EVENT_CENTER ||
      currentPath === ROUTES.INVITE_FRIENDS ||
      currentPath === ROUTES.AGENT_CENTER ||
      currentPath === ROUTES.VIP ||
      currentPath === ROUTES.ACCOUNT_DETAILS
    );
  };

  const isHomePage = () => {
    const currentPath = getCurrentPath();
    return currentPath === ROUTES.HOME || currentPath === ROUTES.HOME_ALT;
  };

  const handleRefresh = async () => {
    window.location.reload();
  };

  return (
    <AntdLayout
      id="gbRoot"
      className={`mobile-layout layout-optimized ${className}`}
      variant={variant}
      testId={testId}
    >
      {shouldShowHeader() && (
        <AntdHeader className="mobile-layout__header" variant={variant}>
          {/* DownloadAppBar 暂时隐藏 */}
          {isHomePage() && downloadAppBarVisible && <DownloadAppBar />}
          <Header variant={isHomePage() ? "home" : "subpage"} />
        </AntdHeader>
      )}

      <AntdContent
        className="mobile-layout__content"
        style={
          shouldShowHeader()
            ? {
                // 首页：header 透明叠在 Banner 上，正常不预留高度（0rem）；
                // 开启顶部下载条时，header 会整体下移 3rem（见 Header marginTop），
                // 此处内容也需同步下移 3rem，否则被下移的 logo 会压到 Banner 文案上。
                marginTop: isHomePage()
                  ? downloadAppBarVisible
                    ? "3rem"
                    : "0rem"
                  : "4rem",
              }
            : undefined
        }
      >
        <PullToRefresh onRefresh={handleRefresh} canRefresh={!cannotRefresh}>
          {children}
        </PullToRefresh>
      </AntdContent>

      <AntdFooter className="mobile-layout__footer" variant={variant}>
        <BottomNavigation
          activeItem={getActiveItem()}
          onItemClick={handleBottomNavClick}
        />
      </AntdFooter>
    </AntdLayout>
  );
};

export default Layout;
